import VDMDashboard from "components/app/vdmdashboard/VDMDashboard";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { rootRoutes } from "routes";
import ScreenVDMDashboardBunker from "./bunker";
import ScreenVDMDashboardConsumption from "./consumption";
import ScreenVDMDashboardPortCalls from "./port-calls";
import ScreenVDMChemicalROBS from "./chemical-robs";
import ScreenVDMDashboardInspection from "./inspection";
import ScreenVDMDashboardWeather from "./weather";
import ScreenVDMDashboardStoppages from "./stoppages";
import ScreenVDMDashboardLubeOils from "./lube-oils";
import ScreenVDMDashboardLNGConsumption from "./lng-consumption";
import ScreenVDMDashboardPIC from "./pic";
import ScreenVDMDashboardSecurity from "./security";

const {
	bunkerRobs,
	bunkerConsumption,
	portCalls,
	chemicalRobs,
	inspection,
	weather,
	stoppages,
	lubeOils,
	lngConsumption,
	security,
	pic,
} =
	rootRoutes.children.app.children.vessel.children.onboard.children.vdmdashboard
		.children;
type ScreenVDMDashboardProps = React.PropsWithChildren<{}>;
const ScreenVDMDashboard: React.FC<ScreenVDMDashboardProps> = (
	props: ScreenVDMDashboardProps
) => {
	return (
		<VDMDashboard>
			<Switch>
				<>
					<Route
						path={portCalls.path}
						component={ScreenVDMDashboardPortCalls}
					/>
					<Route path={bunkerRobs.path} component={ScreenVDMDashboardBunker} />
					<Route
						path={bunkerConsumption.path}
						component={ScreenVDMDashboardConsumption}
					/>
					<Route path={chemicalRobs.path} component={ScreenVDMChemicalROBS} />
					<Route
						path={inspection.path}
						component={ScreenVDMDashboardInspection}
					/>
					<Route path={weather.path} component={ScreenVDMDashboardWeather} />
					<Route
						path={stoppages.path}
						component={ScreenVDMDashboardStoppages}
					/>
					<Route path={lubeOils.path} component={ScreenVDMDashboardLubeOils} />
					<Route
						path={lngConsumption.path}
						component={ScreenVDMDashboardLNGConsumption}
					/>
					<Route path={security.path} component={ScreenVDMDashboardSecurity} />
					<Route path={pic.path} component={ScreenVDMDashboardPIC} />
				</>
			</Switch>
		</VDMDashboard>
	);
};

export default ScreenVDMDashboard;
